import { useEffect, useState } from "react";
import UniSpinnerClassic from "./UniSpinnerClassic";


//
const YourmapMapPageWrapper = (props) => {
  /*
  handleClickGoBack={handleClickGoBack}
  _goBack_href={_goBack_href}
  */
  let _cbGoBack = () => { };
  if (typeof props.handleClickGoBack === 'function') {
    // props?._cbGoBack?.()
    _cbGoBack = props.handleClickGoBack;
  }

  const hideSidebar = props.hideSidebar === true;
  const [showInfoBar, setShowInfoBar] = useState(true);

  useEffect(() => {
    if (props.jsxSidebar === null && props.mapFetching !== true) {
      setShowInfoBar(true);
      const timeoutId = setTimeout(() => {
        setShowInfoBar(false);
      }, 5000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    setShowInfoBar(false);
  }, [props.jsxSidebar, props.mapFetching]);

  return (
    <div className="yourmap__map-widget-pack unirole-scope-without-default-transition">
      <div className="yourmap__map-widget-pack__fix-header-push"></div>
      <div className="yourmap__map-widget-pack__header">
        <a className="yourmap__map-widget-pack__header__go-back-btn" href={props._goBack_href} onClick={_cbGoBack}>
          <i className="fa fa-arrow-left" aria-hidden="true"></i>
          <span className="yourmap__map-widget-pack__header__go-back-btn__label">&nbsp;Nazad</span>
        </a>
        <div className="yourmap__map-widget-pack__header__divider" aria-hidden="true"></div>
        <div className="yourmap__map-widget-pack__header__injected">
          {props.jsxMapHeader}
        </div>
      </div>
      <div className="yourmap__map-widget-pack__body">
        <div className="yourmap__map-widget-pack__main">
          <div className="yourmap__map-widget-pack__map-parent-border yourmap__map-widget-pack__bg-map-checkboard222">
            <div className="yourmap__map-widget-pack__border-fix yourmap__map-widget-pack__border-fix--top yourmap__map-widget-pack__bg-map-checkboard"></div>
            <div className="yourmap__map-widget-pack__border-fix yourmap__map-widget-pack__border-fix--bottom yourmap__map-widget-pack__bg-map-checkboard"></div>
            <div className="yourmap__map-widget-pack__border-fix yourmap__map-widget-pack__border-fix--left yourmap__map-widget-pack__bg-map-checkboard"></div>
            <div className="yourmap__map-widget-pack__border-fix yourmap__map-widget-pack__border-fix--right yourmap__map-widget-pack__bg-map-checkboard"></div>
            <div className="yourmap__map-widget-pack__corner-square yourmap__map-widget-pack__corner-square--1"></div>
            <div className="yourmap__map-widget-pack__corner-square yourmap__map-widget-pack__corner-square--2"></div>
            <div className="yourmap__map-widget-pack__corner-square yourmap__map-widget-pack__corner-square--3"></div>
            <div className="yourmap__map-widget-pack__corner-square yourmap__map-widget-pack__corner-square--4"></div>
            <div className="yourmap__map-widget-pack__map-parent unirole-scope-without-default-transition">
              {/*
              <div className="yourmap__map-widget-pack__map-target" id="map-dom-target">
                <div className="IF_YOU_SEE_THIS_MAP_IS_NOT_RENDERED">IF YOU SEE THIS MAP IS NOT RENDERED</div>
              </div>
              */}
              {
                props.mapFetching === true ? (
                  <div className="yourmap__fetching-overlay"><UniSpinnerClassic />&nbsp;Please wait...</div>
                ) : (
                  <>{props.children}</>
                )
              }
              {props.jsxSidebar === null && showInfoBar === true && (
                <div className="yourmap__map-widget-pack__info-bar" aria-live="polite">
                  <i className="fa fa-info-circle" aria-hidden="true"></i>
                  <span>&nbsp;Klikni na marker da vidiš detalje.</span>
                </div>
              )}
              {props.jsxMapLegend}
            </div>
          </div>
        </div>
        {!hideSidebar && (
          <div className="yourmap__map-widget-pack__map-sidebar" id="map-dom-sidebar">
            <div className="yourmap__card yourmap__card--map-sidebar uu-shadow-alien-fluent2-tile-shadow">{
              props.jsxSidebar === null ? (
                <div className="yourmap__map-widget-pack__sidebar-placeholder">
                  <div className="yourmap__map-widget-pack__sidebar-placeholder__icon-wrap">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                  </div>
                  <p className="yourmap__map-widget-pack__sidebar-placeholder__title">Izaberi marker</p>
                  <p className="yourmap__map-widget-pack__sidebar-placeholder__text">Klikni na marker na mapi da vidiš detalje, slike i kontakt informacije.</p>
                </div>
              ) : (
                <>{props.jsxSidebar}</>
              )
            }</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default YourmapMapPageWrapper;